import React, { useState, useCallback } from "react";
import { Button, Form, Input, Loader } from "semantic-ui-react";
import { Container, Title } from "./styles";
import { producaov2 as api } from "../../../../services/apis";

import { Link } from "react-router-dom";
import swal from "sweetalert";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { toast } from "react-toastify";

const Liberacao = () => {
  const [courseId, setCourseId] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (e) => {
      if (!courseId) {
        swal("Ops !", "Curso em branco", "error");
        return;
      }

      setLoading(true);

      try {
        e.preventDefault();

        await api
          .post(`/admin/curso/unlock/${courseId}`, {
            headers: {
              access_token: `voitto-token ${localStorage.getItem(
                "oauth_token"
              )}`,
            },
          })
          .then((res) => {
            if (res.data) {
              toast.success("A operação foi concluida com sucesso!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setLoading(false);

              return;
            }

            toast.error("A operação foi concluida sem sucesso!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setLoading(false);
          })
          .catch((err) => {
            toast.success(
              `Um erro ocorreu internamente: ${err} , acione o TI!`,
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
            setLoading(false);
          });
      } catch (err) {
        swal("Ops !", err, "error");
        setLoading(false);
      }
    },
    [courseId]
  );

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <Title>Liberar Curso</Title>

        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Id curso</label>
              <Input
                placeholder="Id curso"
                name="curso"
                value={courseId}
                onChange={(e) => setCourseId(e.target.value)}
              />
            </Form.Field>
          </Form.Group>
          {loading ? (
            <Loader active inline="centered" size="massive" />
          ) : (
            <Form.Group>
              <Form.Field>
                <Button onClick={handleSubmit}>Liberar</Button>
              </Form.Field>
              <Link to="/admin/ead/certificados">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          )}
        </Form>
      </Container>
    </div>
  );
};

export default Liberacao;
